import HeaderBar from '~/components/layout/Header/HeaderBar';
import { HeaderProvider } from '~/components/layout/Header/HeaderContext';
import MobileNavigation from '~/components/layout/Header/MobileNavigation';
import { useHeader } from '~/components/layout/Header/useHeader';

interface HeaderProps {
  variant?: 'light' | 'dark';
  wrapLogoInH1?: boolean;
}

const Header = ({ variant = 'dark', wrapLogoInH1 = false }: HeaderProps) => {
  const header = useHeader();

  return (
    <HeaderProvider
      value={{ ...header, variant, wrapLogoInH1 }}
    >
      <HeaderBar />
      <MobileNavigation />
    </HeaderProvider>
  );
};

export default Header;
